
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.25 10A6.25 6.25 0 1110 3.75 6.25 6.25 0 0116.25 10z","fill":"none","stroke":"#005FE8","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.5 10A2.5 2.5 0 1110 7.5a2.5 2.5 0 012.5 2.5zM10 3.334V1.667M3.334 10H1.667M10 16.667v1.667M16.667 10h1.667","fill":"none","stroke":"#005FE8","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    